import type { PayloadAction } from "@reduxjs/toolkit";

/**
 * Shared parts of LocalPaymentInfo — plan §5.2. Mobile is a strict SUBSET: identical state
 * (3 fields, same defaults) and 4 identical reducers, 0 divergent. Web adds
 * `updateLocalPaymentInfoSlice` and the (empty-bodied) logout `extraReducers`.
 *
 * ⚠️ `action` must be `PayloadAction<any>`, never `any` — see the ledger.
 */
export interface SharedLocalPaymentState {
  paymentInfo: any,
  bottomStrip: any,
  isLoadingConfig: boolean
}

export const sharedInitialState: SharedLocalPaymentState = {
  paymentInfo: {},
  bottomStrip: {},
  isLoadingConfig: false
};

/** Identical in both apps — every mobile reducer is here. */
export const sharedReducers = {
  updateLocalPaymentInfo: (state: SharedLocalPaymentState, action: PayloadAction<any>) => {
    state.paymentInfo = action.payload;
  },
  updateStrip: (state: SharedLocalPaymentState, action: PayloadAction<any>) => {
    state.bottomStrip = action.payload;
  },
  fetchDeviceConfig: (state: SharedLocalPaymentState, action: PayloadAction<any>) => {
    state.isLoadingConfig = true;
  },
  fetchDeviceConfigApiResponse: (state: SharedLocalPaymentState, action: PayloadAction<any>) => {
    state.isLoadingConfig = false;
  },
};
